import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles({
  root: {
    width: '100%',
    border: '1px solid #aaa',
    overflowY: 'hidden',
    overflowX: 'scroll',
    whiteSpace: 'nowrap',
    borderRadius: '1vh',
    background: '#fff',
    paddingBottom: '10px',
  },
  floatLeft: {
    display: 'inline-block',
    // borderLeft: '1px solid #aaa',
    height: '100%',
    verticalAlign: 'bottom',
    overflow: 'hidden',
  },
  floatLeftNotBorder: {
    display: 'inline-block',
    height: '100%',
    verticalAlign: 'bottom',
    overflow: 'hidden',
  },
  rootFill: {
    display: 'flex',
    overflowX: 'auto',
  },
  normalFill: {
    flex: '1 1 auto',
    minWidth: 0,
    width: 'auto',
  },
  actionFill: {
    flex: '0 0 auto',
  },
});
